// extracted by mini-css-extract-plugin
export default {"container":"thumbnail_container__Ns5p3","info":"thumbnail_info__248RG","title":"thumbnail_title__2SU8k","description":"thumbnail_description__3Zw4m","line":"thumbnail_line__1pjCX"};